type ConfirmationText = {
  dialogTitle: string;
  dialogContent: string;
  dialogCloseText: string;
  dialogButtonText: string;
};

export const ARCHIVE_EVENT_CONFIRMATION: ConfirmationText = {
  dialogTitle: 'Archive event',
  dialogContent: 'Archive this event? It will move to Archived.',
  dialogCloseText: 'Cancel',
  dialogButtonText: 'Archive',
};

export const REMOVE_ASSET_CONFIRMATION: ConfirmationText = {
  dialogTitle: 'Remove asset',
  dialogContent: 'Remove this asset from the event?',
  dialogCloseText: 'Cancel',
  dialogButtonText: 'Remove',
};

export const removeTaskConfirmation = (taskName: string): ConfirmationText => ({
  dialogTitle: 'Remove task',
  dialogContent: `Are you sure you want to remove ${taskName} from your response plan?`,
  dialogCloseText: 'No, cancel',
  dialogButtonText: 'Yes, remove',
});
